import styled from "styled-components";
import { FormButton, FormButtonCancel } from "../Form";
import OtpInput from "react-otp-input";

export const Modal = styled.div`
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const ModalBg = styled.div`
  z-index: 9;
  width: 100%;
  height: 500%;
  top: 0;
  left: 0;
  position: fixed;
`;
export const ModalContent = styled.div`
  position: relative;
  z-index: 12;
  width: 670px;
  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  padding: 48px 48px;
  margin: auto;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      //max-height: 100%;
      //overflow-y: auto;
      border-radius: 20px;
    }
  }
`;

export const Head = styled.div`
  position: relative;

  & .close {
    position: absolute;
    top: -12px;
    right: 0;
  }

  @media screen and (max-width: 1024px) {
    & > div {
      margin-bottom: 32px;
    }

    & .close {
      width: 26px;
      height: 26px;
      top: 0px;
      right: 0;
    }
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  height: 29px;
  text-align: center;
  letter-spacing: -0.96px;
  box-sizing: unset !important;
  color: #000000;
  &:after{
    box-sizing: unset !important;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  margin-top: 24px;
`;

export const FormButton2 = styled(FormButton)`
  @media screen and (max-width: 1024px) {
    & {
      width: 155px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;

export const CloseIcon = (props) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5469 14.0001L27.6797 1.86721C28.1069 1.44005 28.1069 0.747482 27.6797 0.320373C27.2525 -0.106736 26.56 -0.106791 26.1329 0.320373L14 12.4532L1.86721 0.320373C1.44005 -0.106791 0.747482 -0.106791 0.320373 0.320373C-0.106736 0.747537 -0.106791 1.4401 0.320373 1.86721L12.4532 14L0.320373 26.1329C-0.106791 26.56 -0.106791 27.2526 0.320373 27.6797C0.533928 27.8933 0.813873 28 1.09382 28C1.37376 28 1.65365 27.8933 1.86726 27.6797L14 15.5469L26.1328 27.6797C26.3464 27.8933 26.6263 28 26.9063 28C27.1862 28 27.4661 27.8933 27.6797 27.6797C28.1069 27.2525 28.1069 26.56 27.6797 26.1329L15.5469 14.0001Z"
        fill="#979797"
      />
    </svg>
  );
};

export const Steps = styled.div``;
export const Step = styled.div`
  background: #fff;
  padding: 25px 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  div {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    >div:first-of-type{
      min-width: 50px;
      display: flex;
      justify-content: flex-end;
      span{
        background-color: #000;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    flex: 1;
  }

  li {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #4f4f4f;
    &:first-of-type{
      color: #000;
      font-weight: 600;
      margin-bottom: 10px;
    }
  }

  span {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #4f4f4f;
    margin-right: 12px;
    display: block;
  }

  @media screen and (max-width: 1024px) {
    & span,
    & li {
      font-size: 14px;
      line-height: 18px;
    }

    & span {
      margin-right: 9px;
      width: 50px;
      display: block;
    }
  }
`;
export const StepQR = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 32px 0 16px 0;

  img {
    width: 180px;
    height: 180px;
  }
`;
export const SecretKey = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  span {
    font-weight: 500;
    margin-bottom: 5px;
    font-size: 16px;
    line-height: 30px;
    color: #4f4f4f;
    margin-right: 12px;
    display: flex;
    /* width: 120px; */
    width: 100%;
    @media screen and (max-width: 1024px) {
      & {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    & {
      flex-wrap: wrap;
    }
  }
`;

const InputOtpView = styled.div`
  & > div > div {
    margin: 0 8px;
  }

  & > div > div:last-child {
    margin-right: 0;
  }

  & > div > div:first-child {
    margin-left: 0;
  }

  & > div > div > input {
    border: none !important;
    border-radius: 0;
    border-bottom: 1px solid #4f4f4f !important;
    width: 38px !important;
    padding: 0;
    color: #000000 !important;
    font-weight: 400;
    outline: none;
    font-size: 18px;
    background: rgba(0, 0, 0, 0);
    @media screen and (max-width: 640px) {
      width: 20px !important;
    }
  }

  @media screen and (max-width: 1024px) {
    & > div {
      display: inline-flex;
      margin: 0 auto;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &.inline > div {
      justify-content: flex-start;
    }
  }
`;
export const InputOtp = (props) => {
  return (
    <InputOtpView className={props?.className}>
      <OtpInput
        isInputNum={true}
        numInputs={6}
        value={props?.value || ""}
        onChange={(otp) => {
          if (props.onChange) {
            props.onChange(otp);
          }
        }}
      />
    </InputOtpView>
  );
};

export const OtpTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #4f4f4f;
  margin-bottom: 20px;
`;
export const OtpDesc = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #535353;
  margin-bottom: 60px;
`;
export const Resent = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #4d67c1;
  margin-top: 28px;
  text-align: center;
`;
